/* eslint-disable jsx-a11y/control-has-associated-label */
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripVertical } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import GroupsIcon from "../../../assets/icons/groups.svg2";
import HelpButton from "../../HelpContent/HelpButton";

export default function GroupsWidget() {


  return (
    <div className="position-relative px-2 d-flex flex-column h-100">

      <div className="d-flex p-3 pb-1 align-items-center ">
        <GroupsIcon width={20} className="white opacity-50" />{" "}
        <Link className="btn p-0 text-white" to="/assets/contacts/groups">
          <h6 className="m-0 mx-2 small fw-bold">GROUPS </h6>
        </Link>
        <HelpButton helpKey="widget-groups" iconClassName="white" />
        <FontAwesomeIcon
          icon={faGripVertical}
          className="ms-4 opacity-50 widget-header"
        />
      </div>
      <div className=" overflow-auto">
        <hr className="m-1" />
        <div className="d-flex justify-content-between px-3">
          <span className="fw-bold p-1 opacity-50">Number of groups</span>
          <h3 className="fw-bold m-0 p-1">{5}</h3>
        </div>
        <hr className="m-1" />
        <div className="d-flex justify-content-between px-3">
          <span className="fw-bold p-1 small opacity-50">Static</span>
          <h3 className="fw-bold m-0 p-1 small">{2}</h3>
        </div>
        <div className="d-flex justify-content-between px-3">
          <span className="fw-bold p-1 small opacity-50">Dynamic</span>
          <h3 className="fw-bold m-0 p-1 small">{3}</h3>
        </div>{" "}
        {[
          {
            label: <div className="opacity-50">Empty groups</div>,
            value: <div>{0}</div>,
          },
          {
            label: (
              <div className="opacity-50">
                Number of groups connected to Logics
              </div>
            ),
            value: <div>{1}</div>,
          },
          {
            label: (
              <div className="opacity-50">
                Number of groups connected to critical events
              </div>
            ),
            value: <div>{0}</div>,
          },
          {
            label: <div className="opacity-50">% of groups used</div>,
            value: <div>{40}</div>,
          },
        ].map((r, i) => (
          <React.Fragment key={i}>
            <hr className="m-1" />
            <div className="d-flex justify-content-between px-3">
              <span className="fw-bold p-1">{r.label}</span>
              <h3 className="fw-bold m-0 p-1">{r.value}</h3>
            </div>
          </React.Fragment>
        ))}
      </div>
      <div className="flex-grow-1" />
    </div>
  );
}
